import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, catchError } from 'rxjs'

import { environment } from '../../environments/environment'

import { ErrorService } from './error.service'
import { Role } from '../types/roles'

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private http = inject(HttpClient)
  private errorService = inject(ErrorService)

  private URL = environment.baseUrl + 'roles'

  getAll(): Observable<Array<Role>> {
    return this.http
      .get<Array<Role>>(this.URL)
      .pipe(catchError(this.errorService.handleError))
  }

  /**
   * Sends request to get roles used for selective disclosure
   * @returns {Observable<Array<Role>>} Roles
   */
  getForSelectiveDisclosure(): Observable<Array<Role>> {
    return this.http
      .get<Array<Role>>(this.URL + '/selective-disclosure')
      .pipe(catchError(this.errorService.handleError))
  }
}
